import {getAuthService} from '../../services/authService.js'
import router from '../../router/index'

export const state = {
    currentUser: sessionStorage.getItem('authUser'),
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
        saveState('authUser', newValue)
        if (newValue && newValue.access_token)
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${newValue.access_token}`;
        else
            window.axios.defaults.headers.common['Authorization'] = "Bearer "
    },
}

export const getters = {
    // Whether the users is currently logged in.
    loggedIn(state) {
        return !!state.currentUser
    },
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({state, dispatch}) {
        dispatch('validate')
    },

    // Logs in the current users.
    logIn({commit, dispatch, getters}, {email, password} = {}) {
        if (getters.loggedIn) return dispatch('validate')
        return getAuthService().loginUser(email, password).then((response) => {
            const user = response
            commit('SET_CURRENT_USER', user)
            router.push('/')
            return user
        });
    },

    // Logs out the current users.
    logOut({commit}) {
        commit('SET_CURRENT_USER', null)
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            getAuthService().logout()
            resolve(true);
        });
    },

    // register the users
    register({commit, dispatch, getters}, {email, password} = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return getAuthService().registerUser(email, password).then((response) => {
            const user = response
            commit('SET_CURRENT_USER', user)
            return user
        });
    },


    // Validates the current users's token and refreshes it
    // with new data from the API.
    // eslint-disable-next-line no-unused-vars
    validate({commit, state}) {
        const user = getAuthService().getAuthenticatedUser();
        if (!user) return Promise.resolve(null)
        commit('SET_CURRENT_USER', user)
        return user;
    },
}

// ===
// Private helpers
// ===

function saveState(key, state) {
    sessionStorage.setItem(key, JSON.stringify(state))
}
